export default __webpack_public_path__ + "static/media/Bg-1.ab43ae62.png";